/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Buyside_DescriptionInputs */

const en_landing_capability_buyside_description = /** @type {(inputs: Landing_Capability_Buyside_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let Buy-Side clients query your research inside their own agentic workflows, moving beyond PDFs and email.`)
};

/**
* | output |
* | --- |
* | "Let Buy-Side clients query your research inside their own agentic workflows, moving beyond PDFs and email." |
*
* @param {Landing_Capability_Buyside_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_buyside_description = /** @type {((inputs?: Landing_Capability_Buyside_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Buyside_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_buyside_description(inputs)
});